<template>
  <div class="general-info under-department-list-block">
    <div class="general-info__container">
      <div
        v-if="sectionHeading || description || showThankYou"
        class="general-info-department"
      >
        <div class="general-info-department__info-block">
          <div v-if="sectionHeading" class="general-info-department__title-left">
            <p class="text-TTDrugs-Bold-40 color-green center text-uppercase">{{ sectionHeading }}</p>
          </div>
          <div v-if="description" class="general-info-department__description">
            <p class="text-circe-20 color-gray">{{ description }}</p>
          </div>
        </div>
        <div v-if="showThankYou" class="general-info-department__thank">
          <BlockThankYou />
        </div>
      </div>
      <AppLoader v-if="isLoading" />
      <div
        v-else-if="underDepartments && underDepartments.length"
        class="general-info-under-department"
      >
        <AppUnderDepartmentList :linksDepartment="linksDepartment" />
      </div>
    </div>
  </div>
</template>

<script>
import BlockThankYou from '@/components/BlockThankYou.vue'
import AppUnderDepartmentList from '@/components/UnderDepartment/UnderDepartmentList.vue'
import AppLoader from '@/components/Loader.vue'
import { actionTypesDepartment } from '@/store/modules/department'
import { mapState } from 'vuex'

export default {
  name: 'AppUnderDepartmentListBlock',
  components: { BlockThankYou, AppUnderDepartmentList, AppLoader },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      localLoading: false,
    }
  },
  computed: {
    ...mapState({
      underDepartments: (state) => state.department.underDepartments,
      storeLoading: (state) => state.department.isLoading,
    }),
    departmentName() {
      return ((this.data && this.data.departmentName) || '').trim()
    },
    linksDepartment() {
      const raw = ((this.data && this.data.linksDepartment) || '').trim()
      if (!raw) return 'department'
      // «department/policlinika» → «policlinika» (param маршрута UnderDepartment)
      const parts = raw.replace(/^\//, '').split('/').filter(Boolean)
      if (parts[0] === 'department' && parts.length >= 2) {
        return parts[1]
      }
      return parts[parts.length - 1] || raw
    },
    sectionHeading() {
      return (this.data && this.data.sectionHeading) || ''
    },
    description() {
      return (this.data && this.data.description) || ''
    },
    showThankYou() {
      return !!(this.data && this.data.showThankYou)
    },
    isLoading() {
      return this.localLoading || this.storeLoading
    },
  },
  watch: {
    departmentName: {
      immediate: true,
      handler(val) {
        if (val) this.loadUnderDepartments(val)
      },
    },
  },
  methods: {
    loadUnderDepartments(name) {
      this.localLoading = true
      this.$store
        .dispatch(actionTypesDepartment.getUnderDepartment, name)
        .catch(() => {})
        .finally(() => {
          this.localLoading = false
        })
    },
  },
}
</script>

<style scoped>
</style>
